import useFetch from '../../hooks/useFetch'
import { useState } from 'react'
import { urlApi } from '../../config'
import Alert from '../Alert'
import LobbyActionResult, { restoreSummaryLines } from './LobbyActionResult'

export default function UncancelLobby({ lobby }) {
  const [alert, setAlert] = useState(true)
  const { loading, responseOk, data } = useFetch(`${urlApi}/admin/lobbies/uncancel/${lobby._id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return (
    <Alert
      visible={alert}
      onClose={() => {
        if (!responseOk) {
          setAlert(false)
        } else {
          window.location.reload()
        }
      }}
      hideButton={loading}
    >
      <LobbyActionResult
        loading={loading}
        ok={responseOk}
        title='Viaje restaurado.'
        lines={restoreSummaryLines(data?.refund_choices)}
      />
    </Alert>
  )
}
